export default __webpack_public_path__ + "static/10_16-720788d83ed0fb65af068d47b2428651.png";